import { render, staticRenderFns } from "./GridFabricSelect.vue?vue&type=template&id=922dbe5c&scoped=true&"
import script from "./GridFabricSelect.vue?vue&type=script&lang=js&"
export * from "./GridFabricSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922dbe5c",
  null
  
)

export default component.exports